export default __webpack_public_path__ + "static/media/hills-with-white-notch-large.c08d917f.svg";